export default __webpack_public_path__ + "static/Spartan-4c469e1fe6042ca6c80bb5a94339ba8c.png";